<template>
    <div>
        <v-dialog
        v-model="dialogInvoice"
        fullscreen
      >
          <v-toolbar flat dark color="#00304E" >
            <v-btn icon dark @click="close()" >
              <v-icon>far fa-times-circle</v-icon>
            </v-btn>
            <v-toolbar-title>Invoice Generator</v-toolbar-title>
          </v-toolbar>
       
        <iframe 
          width="100%"
          height="100%"
          allowfullscreen
          :src="datapdf"></iframe>
      </v-dialog>
      <v-dialog v-model="loading" width="300px">
      <v-card height="100px" class="d-flex justify-center align-center">
        <v-card-text>
          <span class="title font-weight-bold">Loading...</span>
          <div class="text-center">
            <v-progress-linear height="8" indeterminate color="green"></v-progress-linear>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            datapdf:'',
            loading:false
        }
    },
    props :{
        url: String,
        dialogInvoice : Boolean
    },
    watch: {
      url: function(){
        this.getPdf()
      }
    },
    methods: {
        close(){
            this.$emit('close')
        },
        async getPdf(){
          this.loading=true
          var datos = await this.$store.dispatch('getPdf',this.url)
          if(datos.status === 200){
            var file = new Blob([datos.data], {type: 'application/pdf'});
            var fileURL = window.URL.createObjectURL(file);
            this.datapdf = fileURL
            this.loading=false
          }else{
            alert('An error was ocurred when try generate invoice')
          }
          
        }
    },
}
</script>